import React, { Component } from 'react';
import moment from 'moment';
import InputField from '../../components/inputs/inputField';
import ToggleField from '../../components/inputs/toggleField';
import TextAreaField from '../../components/inputs/textAreaField';
import SectionFooter from '../../components/views/SectionFooter';
import API from '../../utils/API';

class RoomBlocks extends Component {
	constructor(props) {
		super(props);
		const { venue } = props;
		
		this.state = {
			editedVenue: {
				roomBlock: venue.roomBlock || {
					datesFlexible: false,
					flexibilityNotes: '',
					dailyGrid: []
				}
			},
			editing: false,
			saving: false
		};
	}

	updateRoomBlock = (field, value) => {
		const { editedVenue } = this.state;
		editedVenue.roomBlock[field] = value;
		this.setState({ editedVenue, editing: true });
	};

	addRoomBlockDay = () => {
		const { editedVenue } = this.state;
		const { dailyGrid } = editedVenue.roomBlock;
		
		// Calculate next night number
		const nextNight = dailyGrid.length > 0 ? dailyGrid[dailyGrid.length - 1].night + 1 : 1;
		
		// Calculate next date based on previous date or event arrival date
		let nextDate = null;
		if (dailyGrid.length > 0 && dailyGrid[dailyGrid.length - 1].date) {
			nextDate = moment(dailyGrid[dailyGrid.length - 1].date).add(1, 'days').format('YYYY-MM-DD');
		} else if (this.props.venue.eventDetails && this.props.venue.eventDetails.arrivalDate) {
			nextDate = moment(this.props.venue.eventDetails.arrivalDate).format('YYYY-MM-DD');
		}
		
		dailyGrid.push({
			date: nextDate,
			night: nextNight,
			singleRooms: 0,
			doubleRooms: 0,
			suiteRooms: 0,
			notes: ''
		});
		
		this.setState({ editedVenue, editing: true });
	};

	removeRoomBlockDay = (index) => {
		const { editedVenue } = this.state;
		editedVenue.roomBlock.dailyGrid.splice(index, 1);
		
		// Recalculate night numbers
		editedVenue.roomBlock.dailyGrid.forEach((day, i) => {
			day.night = i + 1;
		});
		
		this.setState({ editedVenue, editing: true });
	};

	updateRoomBlockDay = (index, field, value) => {
		const { editedVenue } = this.state;
		editedVenue.roomBlock.dailyGrid[index][field] = value;
		this.setState({ editedVenue, editing: true });
	};

	saveDetails = async () => {
		const { editedVenue } = this.state;
		
		this.setState({ saving: true });
		
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/sourced-venues/${this.props.venueId}`,
				{ roomBlock: editedVenue.roomBlock }
			);
			
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (error) {
			console.error('Error saving room blocks:', error);
			this.setState({ saving: false });
		}
	};

	cancelEdit = () => {
		const { venue } = this.props;
		this.setState({
			editedVenue: {
				roomBlock: venue.roomBlock || {
					datesFlexible: false,
					flexibilityNotes: '',
					dailyGrid: []
				}
			},
			editing: false
		});
	};

	render() {
		const { editedVenue, editing } = this.state;
		const { venue } = this.props;
		const { roomBlock } = editedVenue;
		
		// Calculate totals
		const totalRooms = roomBlock.dailyGrid.reduce((sum, day) => {
			return sum + (day.singleRooms || 0) + (day.doubleRooms || 0) + (day.suiteRooms || 0);
		}, 0);
		
		return (
			<>
				<div className="sectionBody">
					<div className="sectionBlock">
						<h2 className="blockHeader">Date Flexibility</h2>
						
						<ToggleField
							label="Are your event dates flexible?"
							checked={roomBlock.datesFlexible}
							onChange={() => this.updateRoomBlock('datesFlexible', !roomBlock.datesFlexible)}
							icons={false}
						/>
						
						{roomBlock.datesFlexible && (
							<TextAreaField
								label="Flexibility Details"
								value={roomBlock.flexibilityNotes}
								onChange={(e) => this.updateRoomBlock('flexibilityNotes', e.target.value)}
								placeholder="Provide additional details about date flexibility..."
								rows={3}
							/>
						)}
					</div>
					
					<div className="sectionBlock">
						<div className="flex aic jcsb mb-20">
							<div>
								<h2 className="blockHeader m-0">Daily Room Block Grid</h2>
								{totalRooms > 0 && (
									<p className="grey small mt-5">Total rooms across all nights: {totalRooms}</p>
								)}
							</div>
							<button className="neu min" onClick={this.addRoomBlockDay}>
								<i className="las la-plus mr-10" />
								Add Another Day
							</button>
						</div>
						
						{roomBlock.dailyGrid && roomBlock.dailyGrid.length > 0 ? (
							<div>
								{roomBlock.dailyGrid.map((day, index) => {
									const dayDate = day.date ? moment(day.date).format('YYYY-MM-DD') : '';
									const dayTotal = (day.singleRooms || 0) + (day.doubleRooms || 0) + (day.suiteRooms || 0);
									
									return (
										<div key={index} className="neuCard p-20 mb-15">
											<div className="flex aic jcsb mb-20">
												<h3 className="m-0">
													<i className="las la-moon mr-10" style={{ color: '#007bff' }} />
													Night {day.night}
												</h3>
												<button
													className="p-10 hover-danger"
													onClick={() => this.removeRoomBlockDay(index)}
													title="Remove this day"
												>
														<i className="las la-trash-alt" />
												</button>
											</div>
											
											<div className="flex wrap" style={{ gap: '15px' }}>
												<div style={{ flex: '1 1 200px' }}>
													<InputField
														label="Date"
														type="date"
														value={dayDate}
														onChange={(e) => this.updateRoomBlockDay(index, 'date', e.target.value)}
													/>
												</div>
												
												<div style={{ flex: '1 1 150px' }}>
													<InputField
															label="Single Rooms"
															type="number"
															value={day.singleRooms || ''}
															onChange={(e) => this.updateRoomBlockDay(index, 'singleRooms', parseInt(e.target.value) || 0)}
															placeholder="0"
														/>
												</div>
												
												<div style={{ flex: '1 1 150px' }}>
													<InputField
															label="Double Rooms"
															type="number"
															value={day.doubleRooms || ''}
															onChange={(e) => this.updateRoomBlockDay(index, 'doubleRooms', parseInt(e.target.value) || 0)}
															placeholder="0"
														/>
												</div>
												
												<div style={{ flex: '1 1 150px' }}>
													<InputField
															label="Suite Rooms"
															type="number"
															value={day.suiteRooms || ''}
															onChange={(e) => this.updateRoomBlockDay(index, 'suiteRooms', parseInt(e.target.value) || 0)}
															placeholder="0"
														/>
												</div>
											</div>
											
											{dayTotal > 0 && (
												<div className="mt-15 p-10" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
													<p className="grey small mb-0">
														<i className="las la-calculator mr-5" />
														Day total: <strong>{dayTotal} room{dayTotal !== 1 ? 's' : ''}</strong>
													</p>
												</div>
											)}
											
											<div className="mt-15">
												<TextAreaField
													label="Notes"
													value={day.notes}
													onChange={(e) => this.updateRoomBlockDay(index, 'notes', e.target.value)}
													placeholder="Any special notes for this day..."
													rows={2}
												/>
											</div>
										</div>
									);
								})}
								</div>
						) : (
							<div className="text-c p-40">
								<i className="las la-bed" style={{ fontSize: '3rem', color: '#ccc' }} />
								<h3 className="mt-15">No room blocks added yet</h3>
								<p className="grey">Click "Add Another Day" to start building your room block grid</p>
							</div>
						)}
					</div>
				</div>
				
				<SectionFooter
					saveEdit={this.saveDetails}
					cancelEdit={this.cancelEdit}
					updatedAt={venue.updatedAt}
					editing={editing}
				/>
			</>
		);
	}
}

export default RoomBlocks;
